var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.66679 6L7.33321 6C7.5752 6 7.79853 5.8818 7.91652 5.691C8.03385 5.5002 8.02718 5.2668 7.89852 5.082L4.56531 0.282C4.44332 0.106799 4.22999 3.29585e-07 4 3.49691e-07C3.77001 3.69798e-07 3.55668 0.1068 3.43469 0.282L0.101478 5.082C-0.0271836 5.2668 -0.0338507 5.5002 0.0834789 5.691C0.201474 5.8818 0.424799 6 0.66679 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallUp);
export default __webpack_public_path__ + "static/media/small-up.a0f91ee3.svg";
export { ForwardRef as ReactComponent };